import React from 'react';

export default function Dashboard({ frotaList = [], financeiroList = [], contratosList = [], setActiveTab }) {
  const frota = Array.isArray(frotaList) ? frotaList : [];
  const financeiro = Array.isArray(financeiroList) ? financeiroList : [];
  const contratos = Array.isArray(contratosList) ? contratosList : [];

  const totalVeiculos = frota.length;
  const emViagem = frota.filter(f => f && f.status === 'Em Viagem').length;
  const disponivel = frota.filter(f => f && f.status === 'Disponível').length;
  const manutencao = frota.filter(f => f && f.status === 'Manutenção').length;

  const receitas = financeiro
    .filter(f => f && f.tipo === 'Receita')
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const despesas = financeiro
    .filter(f => f && f.tipo === 'Despesa')
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const receitasRealizadas = financeiro
    .filter(f => f && f.tipo === 'Receita' && ['Concluído', 'Recebido', 'Pago'].includes(f.status))
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const despesasRealizadas = financeiro
    .filter(f => f && f.tipo === 'Despesa' && ['Concluído', 'Pago'].includes(f.status))
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const saldo = receitasRealizadas - despesasRealizadas;

  const contratosAtivos = contratos.filter(c => c && c.status === 'Ativo').length;
  const contratosConcluidos = contratos.filter(c => c && c.status === 'Concluído').length;

  return (
    <div style={{ width: '100%', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: '24px' }}>
        <span style={{ fontSize: '11px', textTransform: 'uppercase', color: '#777', letterSpacing: '1.5px', fontWeight: 'bold' }}>Visão Geral</span>
        <h2 style={{ fontSize: '24px', fontWeight: '800', margin: '4px 0 0 0' }}>Central Operacional</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginBottom: '24px' }}>
        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Saldo Realizado</span>
          <p style={{ fontSize: '28px', fontWeight: '800', color: saldo >= 0 ? '#32D74B' : '#FF3B30', margin: '10px 0 4px 0' }}>
            R$ {saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
          <span style={{ fontSize: '12px', color: '#666' }}>Caixa (baixas efetivadas)</span>
        </div>

        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Receitas</span>
          <p style={{ fontSize: '28px', fontWeight: '800', color: '#007AFF', margin: '10px 0 4px 0' }}>
            R$ {receitas.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
          <span style={{ fontSize: '12px', color: '#666' }}>Todas as receitas registradas</span>
        </div>

        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Despesas</span>
          <p style={{ fontSize: '28px', fontWeight: '800', color: '#FF3B30', margin: '10px 0 4px 0' }}>
            R$ {despesas.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
          <span style={{ fontSize: '12px', color: '#666' }}>Todas as despesas registradas</span>
        </div>

        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '20px', borderRadius: '8px' }}>
          <span style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Veículos</span>
          <p style={{ fontSize: '28px', fontWeight: '800', color: '#FFD60A', margin: '10px 0 4px 0' }}>{totalVeiculos}</p>
          <span style={{ fontSize: '12px', color: '#666' }}>{emViagem} em viagem · {disponivel} disponíveis</span>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '24px', borderRadius: '8px' }}>
          <h3 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#888', marginBottom: '20px' }}>Status da Frota</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}><span style={{ width: '8px', height: '8px', backgroundColor: '#32D74B', borderRadius: '50%' }}></span>Disponível</span>
              <span style={{ fontWeight: 'bold' }}>{disponivel}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}><span style={{ width: '8px', height: '8px', backgroundColor: '#007AFF', borderRadius: '50%' }}></span>Em Viagem</span>
              <span style={{ fontWeight: 'bold' }}>{emViagem}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}><span style={{ width: '8px', height: '8px', backgroundColor: '#FFD60A', borderRadius: '50%' }}></span>Manutenção</span>
              <span style={{ fontWeight: 'bold' }}>{manutencao}</span>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '24px', borderRadius: '8px' }}>
          <h3 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#888', marginBottom: '20px' }}>Contratos</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', color: '#ccc' }}>Ativos</span>
              <span style={{ fontWeight: 'bold', color: '#007AFF' }}>{contratosAtivos}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', color: '#ccc' }}>Concluídos</span>
              <span style={{ fontWeight: 'bold', color: '#32D74B' }}>{contratosConcluidos}</span>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: '#141414', border: '1px solid #222', padding: '24px', borderRadius: '8px' }}>
          <h3 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#888', marginBottom: '20px' }}>Atalhos</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <button onClick={() => setActiveTab('contratos')} style={{ padding: '16px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', textAlign: 'left', cursor: 'pointer', fontWeight: 'bold' }}>📍 Nova Rota</button>
            <button onClick={() => setActiveTab('frota')} style={{ padding: '16px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', textAlign: 'left', cursor: 'pointer', fontWeight: 'bold' }}>🚛 Frota</button>
            <button onClick={() => setActiveTab('abastecimento')} style={{ padding: '16px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', textAlign: 'left', cursor: 'pointer', fontWeight: 'bold' }}>⛽ Abastecer</button>
            <button onClick={() => setActiveTab('financeiro')} style={{ padding: '16px', backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '6px', color: '#fff', textAlign: 'left', cursor: 'pointer', fontWeight: 'bold' }}>💲 Financeiro</button>
          </div>
        </div>
      </div>
    </div>
  );
}